import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  selected?: boolean;
  showText?: boolean;
}

export const Root = styled.div`
  display: inline-block;
`;

export const Btn = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 41px;
  height: 100%;
  min-height: 35px;
  font-family: Roboto;
  cursor: pointer;
  border-radius: ${(props:IRootProps) => props.selected ? '5px' : ''};
  background-color: ${(props:IRootProps) => props.selected ? C.DARKER_WHITE : ''};
  padding: ${(props: IRootProps) => props.showText ? '0px 14px' : ''};
  position: relative;
  &:hover {
    border-radius: 5px;
    background-color: ${C.DARKER_WHITE};
  }
`;

export const Text = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: #202020;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60px;
  display: ${(props: IRootProps) => props.selected ? '' : 'none'};
`;

export const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: ${(props: IRootProps) => props.selected ? `8px solid ${C.DARK_GRAY}` : '8px solid rgba(0, 0, 0, 0.2)'};
  margin-left: ${(props: IRootProps) => props.selected ? '5px' : ''};
`;

export const Menu = styled.div`
  width: 279px;
  display: none;
  position: absolute;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 51;
  margin-top: 12px;
  padding-bottom: 15px;
`;

export const OptionsContainer = styled.div`
  height: auto;
  max-height: 290px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const Title = styled.div`
  height: 19px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  padding: 23px 34px 14px 34px;
`;

export const Option = styled.div`
  background-color: ${(props: IRootProps) => props.selected? 'rgba(18, 36, 66, 0.05)' : '#ffffff'};
  padding: ${(props: IRootProps) => props.selected? '10px 34px 10px 34px' : '6px 34px 6px 34px'};
  font-size: 16px;
  font-weight: normal;
  color: ${C.DARK_GRAY};
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  width: auto;
  cursor:pointer;
  &:hover{
    background-color: rgba(32, 64, 120, 0.05);
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: 38px;
  left: 12.50px;
  padding: 9px 12px;
  width: fit-content;
  max-width: 200px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  display: flex;
  z-index: 100;
  background-color: ${C.DARKEST_GRAY};
  font-size: 11px;
  font-weight: 500;
  color: ${C.DARKER_WHITE};
`;